import React, { PureComponent } from 'react';
import DateMask from "../../../Common/Components/Mask/DateMask.jsx"

class Titulo extends PureComponent {

    render() {
        const { fechasCierres, tipoCuenta, cuentaTarjetaNumero} = this.props;
        let estadoCuenta = "EN MORA";

        return (
            <div className="row bottom-separator-xs">
                <div className="col-xs-12">
                    <h3>Cuenta {" " + tipoCuenta + " " + cuentaTarjetaNumero}</h3>
                </div>
                <div className="col-xs-12">
                    <div className="div-rectangulo reg-inicial">
                        <label className="rectangulo-label">{/*estadoCuenta*/}</label>
                    </div>
                </div>
                <div className="col-xs-12">
                    <label className="tarjetas label-central-small">Actualizado al <DateMask fecha={fechasCierres && fechasCierres.FechaActualizacionAdintar} /></label>
                </div>
            </div>
        );
    }

};

export default Titulo;